import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-process-completed',
  templateUrl: './process-completed.component.html',
  styleUrls: ['./process-completed.component.scss'],
})
export class ProcessCompletedComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() disableTitle = false;
  @Input() disableDescription = false;
}
